import { useEffect, useState } from "react";
import { Main } from "../pages/Main";
import { Theme } from "theme";
import { onStart, selectInitialLoadComplete } from "startup";
import { store } from "app/store";
import { useAppSelector } from "./hooks";

function App() {
  const [initialDataLoadComplete, setInitialDataLoadComplete] = useState(false);
  const initialDataLoaded = useAppSelector(
    (state) => initialDataLoadComplete || selectInitialLoadComplete(state)
  );

  useEffect(() => {
    onStart();
    document.body.style.backgroundColor = Theme.pageBackground;
  }, []);

  useEffect(() => {
    if (!initialDataLoaded) {
      console.time("Load");
    } else {
      console.timeEnd("Load");
      const state = store.getState();
      const strs: string[] = [];
      strs.push(
        `Leaderboards = ${Object.keys(state.leaderboard.leaderboards).length}`
      );
      strs.push(`Matches = ${Object.keys(state.match.data).length}`);
      strs.push(
        `Pickem Details = ${
          Object.keys(state.pickemDetails.pickemDetails).length
        }`
      );
      strs.push(
        `Tournament = ${Object.keys(state.tournament.tournaments).length}`
      );
      strs.push(`Tour = ${Object.keys(state.tour.tours).length}`);
      strs.push(`Track = ${Object.keys(state.track.data).length}`);

      strs.forEach((log) => console.log(log));
      if (!initialDataLoadComplete) {
        setInitialDataLoadComplete(true);
      }
    }
  }, [initialDataLoaded]);

  return <Main initialDataLoaded={initialDataLoaded} />;
}

export default App;
